var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isPopinDisplayed,
          expression: "isPopinDisplayed",
        },
        {
          name: "observe-visibility",
          rawName: "v-observe-visibility",
          value: { callback: _vm.popin_passSanitaireDisplayed_callback },
          expression: "{ callback: popin_passSanitaireDisplayed_callback }",
        },
      ],
      staticClass: "popin-modal centered",
      attrs: { id: "pass-sanitaire" },
    },
    [
      _c("div", { staticClass: "popin-container" }, [
        _c(
          "div",
          {
            staticClass: "popin-closure",
            on: { click: _vm.popin_passSanitaireClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "popin-closure-responsive",
            on: { click: _vm.popin_passSanitaireClosed },
          },
          [_c("div", { staticClass: "arrow" }, [_vm._v("X")])]
        ),
        _vm._v(" "),
        _vm._m(0),
      ]),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "popin" }, [
      _c("div", { staticClass: "popin-content" }, [
        _c("div", { staticClass: "popin-content-container" }, [
          _c("p", [_vm._v(" ")]),
          _vm._v(" "),
          _c("img", {
            attrs: { src: "/public/assets/images/Pass_Sanitaire_2.jpg" },
          }),
          _vm._v(" "),
          _c("p", [_vm._v(" ")]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }